import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { ProfileTabs, SelectRaw } from '../../../components';

const StartPage = ({ user, showNotification }) => {
	const [startPage, setStartPage] = useState(
		user.get('portal_start_page') || 'trackingboard'
	);
	const [isSaving, setIsSaving] = useState(false);

	const handleStartPageChange = ({ target }) => {
		setIsSaving(true);
		setStartPage(target.value);
		user.set('portal_start_page', target.value);
		user.save().then(() => {
			showNotification({ message: 'Profile Updated', status: 'success' });
			setIsSaving(false);
		});
	};

	return (
		<div className="content-wrapper profile">
			<ProfileTabs activeTab="start-page" />
			<div className="row mt-xl">
				<form className="container form-horizontal">
					<fieldset>
						<label className="col-md-4 control-label">Portal Start Page</label>
						<div className="col-md-4 pb">
							<SelectRaw
								selectedValue={startPage}
								onChange={handleStartPageChange}
								options={[
									{ value: 'trackingboard', label: 'Tracking Board' },
									{
										value: 'patientNotifications',
										label: 'Patient Notifications',
									},
									{ value: 'adtviewer', label: 'ADT Viewer' },
									{ value: 'acrssearch', label: 'ACRS Search' },
									{ value: 'campaigns', label: 'Outreach Campaigns' },
									{ value: 'scheduling', label: 'Scheduling' },
								]}
								disabled={isSaving}
							/>
						</div>
					</fieldset>
				</form>
			</div>
		</div>
	);
};

StartPage.propTypes = {
	user: PropTypes.object,
	showNotification: PropTypes.func,
};

export default StartPage;
